import { Component, Signal, signal, WritableSignal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { PermissionService } from '../../modules/buildings-shared/services/permission.service';

@Component({
  selector: 'app-footer',
  imports: [RouterLink],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {

    permissionService: WritableSignal<PermissionService | undefined> = signal<PermissionService | undefined>(undefined);
    emailSupport: string = 'supporto@geometracaroleo.it';

    constructor(permissionService: PermissionService) {
        this.permissionService.set(permissionService);
    }

    async copyEmailSupportToClipboard(): Promise<void> {
        await navigator.clipboard.writeText(this.emailSupport);
    }
}
